

export default {
    // BASE_URL: 'http://192.168.30.7:8085',
    BASE_URL: 'http://47.98.156.78:8080/ep-admin',
    IMG_URL: 'http://47.98.156.78:8080/ep-admin',
    PUSH_URL: ''
}